<cs-header [disableHideOnScroll]="true" [backButton]="false">
  <cs-header-title [small]="true" [wrap]="isWakeUpOrWeighIn">
    {{ title }}
  </cs-header-title>
  <cs-icon-button header-right icon="close" (click)="onCloseClick()"></cs-icon-button>
</cs-header>

<cs-content [no-scroll]="true">

  <div class="content">
    <!-- Time Input and Weekday Selection -->
    <div class="time-input-section" [class.wake-up-weigh-in]="isWakeUpOrWeighIn" [class.meal]="isMeal">
      <cs-form-field [label]="timeLabel">
        <cs-input-time [(time)]="selectedTime" (timeChange)="onTimeChange($event)"></cs-input-time>
        @if (isMeal && conflictingMealNumber !== null) {
          <cs-text-alert
            type="error"
            [message]="LL.reschedule.errors.timeAlreadyUsed({ mealNumber: conflictingMealNumber })">
          </cs-text-alert>
        }
      </cs-form-field>
      @if (isWorkout && availableWeekdays.length > 0 && selectedOption !== RescheduleOption.AllDays) {
        <cs-form-field
          [label]="LL.reschedule.labels.date()">
          <cs-select [(value)]="selectedDayValue" (valueChange)="onDaySelectionChange($event)"
            [placeholder]="LL.reschedule.weekdaySelect.placeholder()">
            @for (day of availableWeekdays; track day.value) {
              <cs-select-option
                [value]="selectedOption === RescheduleOption.ThisDayOnly ? day.dateISO : day.value"
                [label]="day.label"
                [abbreviatedLabel]="(selectedOption === RescheduleOption.ThisDayOnly ? day.label : day.label.slice(0, 3)) | untranslated"
                [disabled]="day.disabled">
                @if (day.isCurrent) {
                  <cs-badge [label]="LL.reschedule.weekdaySelect.currentBadge()" color="gray"></cs-badge>
                }
                @if (day.hasWorkout && !day.isCurrent) {
                  <cs-badge [label]="LL.dayItems.titles.workout()" color="gray"></cs-badge>
                }
              </cs-select-option>
            }
          </cs-select>
        </cs-form-field>
      }
      <!-- Weigh-In time input (disabled) and help text -->
      @if (isWakeUpOrWeighIn) {
        <cs-form-field [label]="LL.reschedule.labels.weighIn()">
          <cs-input-time [time]="weighInTime" [disabled]="true"></cs-input-time>
          <cs-note>{{ LL.reschedule.weighInHelpText() }}</cs-note>
        </cs-form-field>
      }
    </div>

    @if (!(isScheduleEditingMode && (isWorkout || isMeal))) {
      <div class="line-separator"></div>
    }

    <!-- Radio Options -->
    @if (!(isScheduleEditingMode && (isWorkout || isMeal))) {
      <cs-radio-group [(selected)]="selectedOption"
        (selectedChange)="onOptionChange($event)">
        <!-- Hide ThisDayOnly option in schedule editing mode -->
        @if (!isScheduleEditingMode) {
          <cs-radio [value]="RescheduleOption.ThisDayOnly">
            {{ LL.reschedule.options.thisDayOnly.title() }}
            <cs-note>{{ optionThisDayExplanation }}</cs-note>
          </cs-radio>
        }
        @if (!(isScheduleEditingMode && isWorkout)) {
          <cs-radio [value]="RescheduleOption.AllDays">
            {{ LL.reschedule.options.allDays.title() }}
            <cs-note>{{ optionAllDaysExplanation }}</cs-note>
          </cs-radio>
        }
        @if (isWorkout || !isScheduleEditingMode) {
          <cs-radio [value]="RescheduleOption.ThisWeekday">
            {{ LL.reschedule.options.thisWeekday.title() }}
            <cs-note>{{ optionThisWeekdayExplanation }}</cs-note>
          </cs-radio>
        }
      </cs-radio-group>
    }
  </div>

  <div class="actions">
    <cs-button secondary medium (click)="onCancelClick()">{{ LL.common.buttons.cancel() }}</cs-button>
    <cs-button primary medium [disabled]="conflictingMealNumber !== null" (click)="onSaveClick()">{{ LL.common.buttons.save() }}</cs-button>
  </div>
</cs-content>
